"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDob = void 0;
function validateDob(dob) {
    if (dob instanceof Error)
        return false;
    if (typeof dob !== 'string')
        return false;
    const [year, month, day] = dob.split('-');
    // year, month, day must be present
    if ([year, month, day].filter(Boolean).length !== 3)
        return false;
    const constructedDate = new Date(Number(year), 
    // month is 0 based
    Number(month) - 1, Number(day));
    const currentDate = new Date();
    // date must be valid. invalid date (ie non-leap year)
    // will be coerced into different date which causes value(s)
    // to change
    if (
    // month is 0 based
    constructedDate.getMonth() + 1 !== Number(month) ||
        constructedDate.getFullYear() !== Number(year) ||
        constructedDate.getDate() !== Number(day))
        return false;
    // must be after 1900 and before current time
    if (1900 > constructedDate.getFullYear() ||
        currentDate.getTime() < constructedDate.getTime()) {
        return false;
    }
    return true;
}
exports.validateDob = validateDob;
//# sourceMappingURL=validateDob.js.map